module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-04-dd8310917c5811f2b2a05c59bbaa94e4.jpg";